import * as React from 'react';
import {
  IExecutionStageSummary,
} from '@spinnaker/core';

// Styles
import '../../../styles/terraform/marker-icon.scss';

export interface TerraformMarkerIconProps {
  stage: IExecutionStageSummary;
}

export class TerraformMarkerIcon extends React.Component<{ stage }, TerraformMarkerIconProps> {

  public render() {
    const { stage } = this.props;

    const getStageOutputStatusCode = (): number => {
      return stage.masterStage.outputs.status?.code;
    };
    const getClassNameByStatusCode = (code: number): string => {
      switch (code) {
        case 2:
          return 'success-with-diff';
        default:
          return '';
      }
    };
    const stageOutputStatusCode = getStageOutputStatusCode();
    const classNameByStatusCode = getClassNameByStatusCode(stageOutputStatusCode)


    return (
      <div className={`terraform-marker-icon ${classNameByStatusCode}`} />
    )
  }
}

